import {AlertController, ModalController, NavController, NavParams, ToastController} from "ionic-angular";
import {Component} from "@angular/core";
import {ApplicationVariables, Constants, IMAGES_BASE_URL} from "../../providers/config";
import {CartManager} from "../../providers/cart-manager";
import {Api} from "../../providers/api";
import {Storage} from "@ionic/storage";
import {MsgManager} from "../../providers/msg-manager";
import {GVLogger} from "../../services/gv-logger";
import {Headers, RequestOptions} from "@angular/http";
import {SearchCustomersPage} from "../search-customers/search-customers";
import {Printer, PrintOptions} from "ionic-native";
import {ItemsPage} from "../items/items";
import {CartPage} from "../cart/cart";
import {PickPackParamsPage} from "../pickpackparams/pickpackparams";
import {MyOrderPage} from "../my-order/my-order";
import {LoginPage} from "../login/login";
import {ThankYouModalPage} from "../thank-you-modal/thank-you-modal";
import {LicenseStatusModelPage} from "../license-status-model/license-status-model";
import {CART, loginUserInfo, MOVESTOCKLOCATION, shipmentCART} from "../../providers/data";
import {ProductLocationsModelPage} from "../product-locations-model/product-locations-model";
import {DatePickerProvider} from "ionic2-date-picker";
import {ShipmentcartManagerProvider} from "../../providers/shipmentcart-manager";
import moment from "moment";
import {ItemPage} from "../item-details/item-details";

@Component({
  selector: 'page-shipment-ready',
  templateUrl: 'shipment-ready.html',
})
export class ShipmentReadyPage {

  baseImageUrl = IMAGES_BASE_URL.imageBaseUrl;

  salesPerson;

  currentDate;
  placeOrderButton = true;

  attributesPropertiesMap:any = new Map();
  shipto = '';
  constants = Constants;

  space: string = ", ";
  spaceAddress1 : string;
  spaceAddress2 : string;
  public shipToVal : any = "shipto";
  BOLVariables = [];
  lengthTotalizer = 0;

  adpCustomerInfo :any ={};

  public cart: any;
  public TotalPrice: number = 0;
  public TotalPriceBeforeTax: number = 0;
  public taxPercent = 0; // Changed from 0.13
  public taxAmount = 0;
  public locationSelected: any;
  public locationSelectedObject: any;
  public expectedShipmentDate: any = "";
  public plannedShipmentDate = "";
  public orderMessage = "";
  spaceCity: string;
  spaceState: string;
  spaceCountry: string;
  deoded: string;
  TAX: number = 0;
  order: any;
  selectFirstBillTo: any;
  pickPackParamsVariables: any;
  SoldToCompany;
  SoldToAddress;
  lengthTotalizerr: string;
  lengthTotalizerDecimalFix: string;
  shipOrderButton = true;
  downloadCSVButtonStatus = true;
  private todayDate: string;
  private qty = 0;
  public shipmentNo = "101";
  private pageStatus = "";
  private shipmentStatus: boolean = true;
  private shipmentsLength;
  private totalQtyOfSelectedProducts = 0;
  private getParamsFieldsFromServerside = false;
  // private prodTotalQty= 0;
  private shipmentStatusforOokCheck: boolean = true;
  private paramsFromServer: any;
  plannedShipmentDateFromServer: any = "";
  cartName = "";
  spaceZipCode: any;
  isLoading = false;


  constructor(public nav: NavController,
              private cartManager:CartManager,
              private shipmentCartManager: ShipmentcartManagerProvider,
              private api:Api,public storage: Storage,
              public toastCtrl: ToastController,
              public params:NavParams,
              public alertCtrl: AlertController,
              public msgManager:MsgManager,
              private gVLogger:GVLogger,
              private modalCtrl:ModalController,
              private datePickerProvider:DatePickerProvider) {

    this.attributesPropertiesMap = this.cartManager.getAllAttributesPropertiesMap();
    this.adpCustomerInfo = this.cartManager.getAdpCustomerInfo();

    this.salesPerson = this.cartManager.getSalesPerson();

    this.cart = this.params.get("cart");

    this.order = this.params.get("orderView");
    this.pageStatus = this.params.get("pageStatus");
    this.shipmentsLength = this.params.get("shipmentsLength");

    // alert(this.shipmentsLength + " UD")

    if(this.pageStatus !== undefined && this.pageStatus === "shipment"){
      this.shipmentStatus = false;
      this.plannedShipmentDateFromServer = this.params.get("plannedShipmentDate");
      let shipmentNo = this.params.get("shipmentNo");
      this.cartName = this.cart.orderTitle + "-" + shipmentNo;
    }

    if(this.cart.items.length > 0){
      this.shipOrderButton = false;
    }


    if(this.pageStatus !== undefined && this.pageStatus === "shipmentforOok"){
      this.shipmentStatusforOokCheck = false;
    }


    if(this.shipmentsLength !== undefined && this.shipmentsLength != 0){
      let numericShipment = Number(this.shipmentNo);
      let num = numericShipment + this.shipmentsLength;
      this.shipmentNo = num.toString();
    }

    this.totalQuantityOfSelectedProducts();
    this.getParamsFieldsFromServer();



    // for ( let item of this.cart.items){
    //   this.gVLogger.log("items" + item);
    //   try{
    //     let length = item.name.split('|')[4].split(':')[0];
    //     length = Number(length.trim());
    //
    //     this.lengthTotalizer += length;
    //
    //     this.gVLogger.log("totalizerrrrrrr" + this.lengthTotalizer);
    //   }catch(error){
    //     this.gVLogger.log("error while reading length " + error);
    //   }
    //
    //
    //   item.attributesList = [];
    //
    //   if(!item.attributeSearch){
    //     // item.attributeSearch = "5:2027>6:2764>7:2852>8:2875>9:2879";
    //     this.gVLogger.log("if executed in attribute search : ");
    //     item.attributeSearch = "";
    //   }
    //
    //   if(item.attributeSearch.indexOf('>') !== -1){
    //     this.gVLogger.log("in if .indexOf executed in attribute search : ");
    //     let tempAttributesList = item.attributeSearch.split('>');
    //     for(let attribute of tempAttributesList){
    //       if(attribute!== "")
    //         item.attributesList.push({attributeId:attribute.split(':')[0],activeStatus: this.attributesPropertiesMap.get(attribute.split(':')[0]).attActiveStatus ,orderId:this.attributesPropertiesMap.get(attribute.split(':')[0]).attSequence||0,attribute:this.cartManager.getAttributeValue(attribute.split(':')[0]),attributeValue:this.cartManager.getAttributeValue(attribute)});
    //     }
    //   }
    //   // item.attributesList.sort(function(a,b){return a.orderId-b.orderId})
    // }

    this.setTotalLength();


    // this.shipOrderButton = true;
    this.downloadCSVButtonStatus = true;
    this.lengthTotalizerDecimalFix = this.lengthTotalizer.toFixed(2);

    this.orderMessage = this.cart.orderMessage;
    this.currentDate = new Date();
    // this.currentDate = moment();
    this.expectedShipmentDate = this.cart.expectedShipmentDate;
    this.TotalPriceBeforeTax = params.get("TotalPrice");
    this.TotalPrice = this.TotalPriceBeforeTax + this.taxAmount;
    this.getLocationById();
    this.updateOrderMessageInCART();

    var today = new Date();
    this.gVLogger.log(today);

    let dd:any = today.getDate();
    if( dd>0 && dd<10){
      dd = "0"+dd;
    }
    let mm:any = today.getMonth()+1; //January is 0!
    if( mm>0 && mm<10){
      mm = "0"+mm;
    }
    var yyyy = today.getFullYear();

    this.todayDate = yyyy+"-"+mm+"-"+dd;

  }


  getParamsFieldsFromServer(){
    this.api.get("/adpCust/getIntelliStockParams")
      .map(res => res.json())
      .subscribe((results)=>{
        if(results.status === "200"){
          let paramProvider = this.decode(results.data);
          this.paramsFromServer = JSON.parse(paramProvider);
          this.gVLogger.log("Prams from the server in confirm shipment page : " + this.paramsFromServer);
          setTimeout(() => {
            let paramsCustomFields = this.paramsFromServer.documents.find(item=>item.name=="pickPackShip").documentParams.find(Item=>Item.sectionLabel=="none").fields;
            if(paramsCustomFields.length > 0){
              this.getParamsFieldsFromServerside = true;
            }
          },500)

        }
      });
  }

  convertStringToDate(stringDate){
    // return new Date(stringDate).getMonth() + "/" + new Date(stringDate).getDate() + "/" + new Date(stringDate).getFullYear();
    return moment.utc(stringDate).format("MM/DD/YYYY");
  }


  setTotalLength(){
    this.lengthTotalizer = 0
    for ( let item of this.cart.items){
      this.gVLogger.log("items" + item);
      try{
        let length = item.name.split('|')[4].split(':')[0];
        length = Number(length.trim());

        this.lengthTotalizer += length;

        this.gVLogger.log("totalizerrrrrrr" + this.lengthTotalizer);
      }catch(error){
        this.gVLogger.log("error while reading length " + error);
      }


      item.attributesList = [];

      if(!item.attributeSearch){
        // item.attributeSearch = "5:2027>6:2764>7:2852>8:2875>9:2879";
        this.gVLogger.log("if executed in attribute search : ");
        item.attributeSearch = "";
      }

      if(item.attributeSearch.indexOf('>') !== -1){
        this.gVLogger.log("in if .indexOf executed in attribute search : ");
        let tempAttributesList = item.attributeSearch.split('>');
        for(let attribute of tempAttributesList){
          if(attribute!== "")
            item.attributesList.push({attributeId:attribute.split(':')[0],activeStatus: this.attributesPropertiesMap.get(attribute.split(':')[0]).attActiveStatus ,orderId:this.attributesPropertiesMap.get(attribute.split(':')[0]).attSequence||0,attribute:this.cartManager.getAttributeValue(attribute.split(':')[0]),attributeValue:this.cartManager.getAttributeValue(attribute)});
        }
      }
      // item.attributesList.sort(function(a,b){return a.orderId-b.orderId})
    }

    // this.shipOrderButton = true;
    this.downloadCSVButtonStatus = true;
    this.lengthTotalizerDecimalFix = this.lengthTotalizer.toFixed(2);
  }


  decodeData(encodeData){
    return	this.deoded=atob(encodeData);
  }


  getLocationById(){

    if(this.cart.customer.locationsDTOs[0].dropshipLocation === undefined || this.cart.customer.locationsDTOs[0].dropshipLocation === null)
      this.locationSelectedObject = this.cart.customer.locationsDTOs[0];
    else
      this.locationSelectedObject = JSON.parse(this.cart.customer.locationsDTOs[0].dropshipLocation);

    this.setCommaAddress1();
    this.setCommaAddress2();
    this.setCommaCity();
    this.setCommaState();
    this.setCommaZipCode();
    // this.shipto = [this.locationSelectedObject.addressLine1, this.spaceAddress1, this.locationSelectedObject.addressLine2, this.spaceAddress2,  this.locationSelectedObject.city, this.spaceCity, this.locationSelectedObject.state, this.spaceState, this.locationSelectedObject.country].join("");
    this.shipto = [this.locationSelectedObject.addressLine1, this.spaceAddress1, this.locationSelectedObject.addressLine2, this.spaceAddress2, this.locationSelectedObject.city, this.spaceCity, this.locationSelectedObject.state, this.spaceState, this.locationSelectedObject.zipCode, this.spaceZipCode, this.locationSelectedObject.country].join("");

  }


  setCommaZipCode(){
    if(this.locationSelectedObject.zipCode === "" || this.locationSelectedObject.zipCode === undefined || this.locationSelectedObject.zipCode === null)
    {
      this.spaceZipCode = "";
    }
    else
    {
      this.spaceZipCode = ", ";
    }
  }


  setCommaCity(){
    if(this.locationSelectedObject.city === "" || this.locationSelectedObject.city === undefined || this.locationSelectedObject.city === null)
    {
      this.spaceCity = "";
    }
    else
    {
      this.spaceCity = ", ";
    }
  }


  setCommaState(){
    if(this.locationSelectedObject.state === "" || this.locationSelectedObject.state === undefined || this.locationSelectedObject.state === null)
    {
      this.spaceState = "";
    }
    else
    {
      this.spaceState = ", ";
    }
  }

  setCommaAddress1(){
    if(this.locationSelectedObject.addressLine1 === "" || this.locationSelectedObject.addressLine1 === undefined || this.locationSelectedObject.addressLine1 === null)
    {
      this.spaceAddress1 = "";
    }
    else
    {
      this.spaceAddress1 = ", ";
    }
  }

  setCommaAddress2(){
    if(this.locationSelectedObject.addressLine2 === "" || this.locationSelectedObject.addressLine2 === undefined || this.locationSelectedObject.addressLine2 === null)
    {
      this.spaceAddress2 = "";
    }
    else
    {
      this.spaceAddress2 = ", ";
    }
  }

  // place order
  buy() {

    if(this.expectedShipmentDate == ""){
      this.msgManager.toastMsg("Please select a Shipment Date");
    }else{

      this.placeOrderButton = false;



      var body:any = this.cartManager.genrateOrder(1, loginUserInfo.customerShippingCost); // placeorder status 1


      // this.gVLogger.log(JSON.stringify(body));
      let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({
        headers: headers
      });
      //this.saveOrderOnDisk();
      this.api.post("order/place",JSON.stringify(body), options)
        .map(res => res.json())
        .subscribe(resp => {
            if(resp.status == "401"){ // check for session out
              this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

              this.nav.setRoot(LoginPage);
            }
            if(resp.status="200"){


              this.cartManager.clearCart();
              this.cartManager.setOrderId(0); // orderid after submission
              this.cartManager.setOrderMessage("");

              this.nav.setRoot(SearchCustomersPage);
            }

          }
          , error =>{
            //alert(JSON.stringify(error));
          });

      // back to home page
      // this.nav.setRoot(HomePage);
    }

  }

  clearCart(){
    let confirm = this.alertCtrl.create({
      title: 'Are you sure?',
      message: 'Do you agree to Clear all the Products from cart',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            // this.gVLogger.log('Disagree clicked');
          }
        },
        {
          text: 'Agree',
          handler: () => {
            // this.gVLogger.log('Agree clicked');
            this.cartManager.clearCartProducts();
            this.nav.pop().then(()=>{this.nav.pop()});
          }
        }
      ]
    });
    confirm.present();

  }

  saveOrderOnDisk(){

    // let keys: any = [];

    // let arrKeys = JSON.parse( localStorage.getItem("keys"));
    // let key = this.cart.customer.id + "-" + new Date();
    // alert(arrKeys);
    // if(arrKeys == null){
    //   keys.push(key);
    //   localStorage.setItem("keys",keys);
    //   localStorage.setItem(key,JSON.stringify(this.cart));
    // }else{
    //     arrKeys.push(key);
    //     localStorage.setItem("keys",arrKeys);
    //     localStorage.setItem(key,JSON.stringify(this.cart));
    // }
  }

  shipDateChanged(event){
    this.gVLogger.log("this.expectedShipmentDate : " + event.target.value );
    // this.cartManager.setShipDate(this.expectedShipmentDate);
  }

  updateOrderMessageInCART(){
    this.cartManager.setOrderMessage(this.orderMessage);
  }

  updateOrderMessage($event){
    // this.gVLogger.log("Blured called");
    this.updateOrderMessageInCART();
  }

  doPrint(){
    // alert("Printer is not available");
    this.gVLogger.log("Do print caldedd confirm shipment");
    let options: PrintOptions = {
      name: 'Pick / Pack Ship'
    };

    Printer.isAvailable().then(
      function(){
        alert("Printer is available");
        Printer.print(document.getElementById("print-from"), options).then(function(){},function(){});
      }
      ,
      function(){
        alert("Printer is not available");
      }
    );
  }

  imageNotFound(e,item){
    item.productImagesDTO[0].extension = "png";
    item.productImagesDTO[0].name = "dummy";
  }


  reOrder(){

    // this.gVLogger.log(this.cart.customerDTO);

    if(this.cartManager.getProductsCount()){

      let confirm = this.alertCtrl.create({
        title: 'Are you sure?',
        message: "Do you agree to delete all the Products for '"+ this.cartManager.getCustomerName() +"' from cart",
        buttons: [
          {
            text: 'Goto Cart', // cancel
            handler: () => {
              this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});
            }
          },
          {
            text: 'Discard Cart', // agree
            handler: () => {

              this.addtoCart();

              //     this.cartManager.setCustomer(this.cart.customer);
              // this.cartManager.setOrderMessage(this.cart.orderMessage);
              // this.cartManager.setOrderId(0);
              // this.cartManager.setItems(this.cart.items);
              // //this.nav.push(CartPage);
              //     this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});
            }
          }
        ]
      });
      confirm.present();

    }else{
      this.addtoCart()
    }


  }

  pickPackParams(){
    let cart:any = {};

    // cart.orderId = this.cart.orderId;
    cart.shipmentsIds = [this.cart.orderId];

    let modal = this.modalCtrl.create(PickPackParamsPage,{"cart":cart});
    modal.onDidDismiss(data => {
    });
    modal.present();
  }


  confirmShipment() {

    this.gVLogger.log("OOOOOOOOOOOOOOOOOOOOOOOooOOOOOOOOO " + JSON.stringify(this.cart));

    this.shipOrderButton = true;
    this.isLoading = true;

    // Temporary commented start ud


    // this.api.getADPPay("feature/getLicenseStatus?customerUUID="+this.cartManager.getADPCustomerUUID() + "&featureAlias="+ this.constants.Monthly_License_alias+"&consumptionCount=0").map(res => res.json())
    //   .subscribe(data => {
    //     if(data.status === 570 || data.status === 571 || data.status === 403){
    //       this.presentPaySatusAlert("Failure", data.message);
    //       this.shipOrderButton = false;
    //     }
    //     else if(data.status === 200 || data.status === 270){
    //       let count = 0;
    //       for(let item of this.cart.items){
    //         if(item.productType == 1){
    //           count += 0
    //         }else {
    //           for(let qty of item.productInventoryLocationsDTO){
    //             count += qty.quantityReceived;
    //           }
    //         }
    //       }
    //
    //
    //       this.api.getADPPay("feature/getLicenseStatus?customerUUID="+this.cartManager.getADPCustomerUUID() + "&featureAlias="+ this.constants.fulfilment_topup_License_alias+"&consumptionCount="+count).map(res => res.json())
    //         // this.api.getADPPay("feature/getLicenseStatus?customerUUID="+this.cartManager.getADPCustomerUUID() + "&featureAlias=fulfilment-topup&consumptionCount="+count).map(res => res.json())
    //         .subscribe(data => {
    //           if(data.status === 570 || data.status === 571 || data.status === 403){
    //             this.presentPaySatusAlert("Failure", data.message);
    //             this.shipOrderButton = false;
    //           }
    //           else if(data.status === 200 || data.status === 270) {
    //             this.gVLogger.log("Planned shipment date -" + this.plannedShipmentDate + "-");
    //             if (this.plannedShipmentDate === "" || this.shipmentNo === "") {
    //               this.shipOrderButton = false;
    //               if (this.shipmentNo === "") {
    //                 this.msgManager.toastMsg("Please Enter Shipment No!");
    //               }
    //               else {
    //                 this.msgManager.toastMsg("Please Select a Shipment Date!")
    //               }
    //             } else {
    //               // }
    //               this.shipmentCartManager.clearCart();
    //               this.nav.setRoot(MyOrderPage);
    //               this.placeOrderButton = false;
    //
    //
    //
    //
    //               var body: any = this.cartManager.orderShipment(1, this.cart, this.order, this.shipmentNo, this.plannedShipmentDate); // placeorder status 1
    //               let headers = new Headers({
    //                 'Content-Type': 'application/json'
    //               });
    //               let options = new RequestOptions({
    //                 headers: headers
    //               });
    //
    //               this.api.post("order/confirmShipment", JSON.stringify(body), options)
    //                 .map(res => res.json())
    //                 .subscribe(resp => {
    //                     if (resp.status = "200") {
    //
    //
    //                       this.cartManager.clearCart();
    //                       this.cartManager.setOrderId(0); // orderid after submission
    //                       this.cartManager.setOrderMessage("");
    //                       this.cartManager.setOrderTitle("");
    //                       this.cartManager.setShipingServiceName("");
    //                       this.cartManager.setShippingServiceId("");
    //                       this.storage.remove('savedSignature');
    //                       this.cart.tempShipTo = undefined;
    //
    //                       if (Constants.isWebstore) {
    //                         this.presentThankYouAlert("Order shipment confirmed!", "Please note that the quantities shipped have been adjusted from the quantities on hand inside the system.");
    //                       } else {
    //                         this.presentThankYouAlert("Order shipment confirmed!", "Please note that the quantities shipped have been adjusted from the quantities on hand inside the system.");
    //                       }
    //
    //                       //this.msgManager.toastMsg(this.msgManager.getOrderPlaceSuccessMsg());
    //                       this.nav.setRoot(MyOrderPage).then(() => {
    //                         //this.nav.push(MyOrderPage);
    //                       });
    //                     } else if (resp.status == "401") { // check for session out
    //                       this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
    //
    //                       this.nav.setRoot(LoginPage);
    //                     }
    //
    //                   }
    //                   , error => {
    //                     this.msgManager.toastMsg(this.msgManager.getOrderPlaceFailMsg());
    //                     //alert(JSON.stringify(error));
    //                   });
    //
    //
    //               // back to home page
    //               // this.nav.setRoot(HomePage);
    //             }
    //           }
    //
    //         });
    //     }
    //   });




    // Temporary commented end ud


    this.api.getADPPay("feature/getLicenseStatus?customerUUID="+this.cartManager.getADPCustomerUUID() + "&featureAlias="+ this.constants.Monthly_License_alias+"&consumptionCount=0").map(res => res.json())
      .subscribe(data => {
        if(data.status === 570 || data.status === 571 || data.status === 403){
          this.presentPaySatusAlert("Failure", data.message);
          this.shipOrderButton = false;
          this.isLoading = false;
        }
        else if(data.status === 200 || data.status === 270){
          // let count = 0;
          // for(let item of this.cart.items){
          //   if(item.productType == 1){
          //     count += 0
          //   }else {
          //     for(let qty of item.productInventoryLocationsDTO){
          //       count += qty.quantityReceived;
          //     }
          //   }
          // }


          // this.api.getADPPay("feature/getLicenseStatus?customerUUID="+this.cartManager.getADPCustomerUUID() + "&featureAlias="+ this.constants.fulfilment_topup_License_alias+"&consumptionCount="+count).map(res => res.json())
          //   .subscribe(data => {
              // if(data.status === 570 || data.status === 571 || data.status === 403){
              //   this.presentPaySatusAlert("Failure", data.message);
              //   this.shipOrderButton = false;
              // }
              // else if(data.status === 200 || data.status === 270) {

          let itemsLength = 0;
              for(let item of this.cart.items){

                for(let prod of item.productInventoryLocationsDTO)
                  if(prod.status === 1 && prod.quantityReceived > 0){
                    itemsLength += 1;
                    break;
                  }
          }

              // alert("items " + itemsLength)
                this.gVLogger.log("Planned shipment date -" + this.plannedShipmentDate + "-");
                if (this.plannedShipmentDate === "" || this.shipmentNo === "" || itemsLength < 1) {
                  this.shipOrderButton = false;
                  this.isLoading = false;
                  if (itemsLength < 1) {
                    this.msgManager.toastMsg("Please Select At least One Item!");
                  }

                  else if (this.shipmentNo === "") {
                    this.msgManager.toastMsg("Please Enter Shipment No!");
                  }
                  else {
                    this.msgManager.toastMsg("Please Select a Shipment Date!")
                  }
                } else {
                  // }
                  this.shipmentCartManager.clearCart();
                  // this.nav.setRoot(MyOrderPage);
                  this.placeOrderButton = false;




                  var body: any = this.cartManager.orderShipment(1, this.cart, this.order, this.shipmentNo, this.plannedShipmentDate); // placeorder status 1

                  // alert(body.orderDetailDTOs.length)
                  // if(body.orderDetailDTOs.length < 1){
                  //   this.msgManager.toastMsg("Please Select At least One Item!")
                  //   return;
                  // }
                  let headers = new Headers({
                    'Content-Type': 'application/json'
                  });
                  let options = new RequestOptions({
                    headers: headers
                  });

                  this.api.post("order/confirmShipment", JSON.stringify(body), options)
                    .map(res => res.json())
                    .subscribe(resp => {
                        if (resp.status === "200") {


                          this.cartManager.clearCart();
                          this.cartManager.setOrderId(0); // orderid after submission
                          this.cartManager.setOrderMessage("");
                          this.cartManager.setOrderTitle("");
                          this.cartManager.setShipingServiceName("");
                          this.cartManager.setShippingServiceId("");
                          this.storage.remove('savedSignature');
                          this.cart.tempShipTo = undefined;

                          if (Constants.isWebstore) {
                            this.presentThankYouAlert("Order shipment confirmed!", "Please note that the quantities shipped have been adjusted from the quantities on hand inside the system.");
                          } else {
                            this.presentThankYouAlert("Order shipment confirmed!", "Please note that the quantities shipped have been adjusted from the quantities on hand inside the system.");
                          }

                          //this.msgManager.toastMsg(this.msgManager.getOrderPlaceSuccessMsg());
                          this.nav.setRoot(MyOrderPage).then(() => {
                            //this.nav.push(MyOrderPage);
                          });
                        } else if (resp.status == "403") { // check for session out
                          this.msgManager.toastMsg(resp.message);
                          this.shipOrderButton =false
                          this.isLoading = false;

                        }else if (resp.status == "401") { // check for session out
                          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                          this.nav.setRoot(LoginPage);
                        }

                      }
                      , error => {
                        this.msgManager.toastMsg(this.msgManager.getOrderPlaceFailMsg());
                        //alert(JSON.stringify(error));
                      });


                  // back to home page
                  // this.nav.setRoot(HomePage);
                }
              // }

            // });
        }
      });


  }

  presentThankYouAlert(title,msg){
    let thankyouModal = this.modalCtrl.create(ThankYouModalPage, { title: title ,message: msg });
    thankyouModal.present();
  }

  presentPaySatusAlert(title,msg){
    this.gVLogger.log("LicenseStatusModelPage");
    let thankyouModal = this.modalCtrl.create(LicenseStatusModelPage, { title: title ,message: msg });
    thankyouModal.present();
  }

  addtoCart(){
    this.cartManager.setCustomer(this.cart.customer);
    this.cartManager.setOrderMessage(this.cart.orderMessage);
    this.cartManager.setOrderId(0);
    this.cartManager.setItems(this.cart.items);
    //this.nav.push(CartPage);
    this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});
  }

  discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }




  decimalLengthFixed(num,max){
    return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
  }



  doPrintWeb(){

    this.printToCart("print-from");

  }


  printToCart(printSectionId: string){
    let popupWinindow;
    let innerContents = document.getElementById(printSectionId).innerHTML;
    popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    popupWinindow.document.open();
    popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
    popupWinindow.document.close();
  }

  makeImageURL(dimensions,item){
    return this.cartManager.makeImageURL(dimensions,item);
  }
  billOfLading(){

    this.api.getADPPay("feature/getLicenseStatus?customerUUID="+this.cartManager.getADPCustomerUUID() + "&featureAlias="+ this.constants.EDI_Integrations_License_alias+"&consumptionCount=0").map(res => res.json())
      .subscribe(data => {
        if(data.status === 570 || data.status === 571 || data.status === 403){

          this.presentPaySatusAlert("Failure", data.message);
          // this.presentThankYouAlert("Failure", data.message);
        }
        else if(data.status === 200 || data.status === 270){
          this.bolFormVariables();
          setTimeout(()=> {
            this.printBOL("BOL-form");
          },1000)

        }
      });




  }

  printBOL(printSectionId: string){
    let popupWinindow;
    let innerContents = document.getElementById(printSectionId).innerHTML;
    popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    popupWinindow.document.open();
    popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
    popupWinindow.document.close();
  }


  getSquareLogo(){
    // this.gVLogger.log("url" + IMAGES_BASE_URL + "/" + this.cartManager.getADPCustomerUUID() + "/branding/logoSquare.png?v="+Math.round((new Date()).getTime() / 1000));
    return IMAGES_BASE_URL.imageBaseUrl + "/" + this.cartManager.getADPCustomerUUID() + "/branding/logoSquare.png?v="+Math.round((new Date()).getTime() / 1000);
  }

  imageNotFoundServer(event){
    event.target.src = "http://anydatapoint.net/f9c5c5ba-3900-4cdc-946d-93979d29f33c/branding/default-logo.png";
  }

  handleImgError(ev: any, item : any){
    let source = ev.srcElement;
    let imgSrc = "http://anydatapoint.net/f9c5c5ba-3900-4cdc-946d-93979d29f33c/branding/default-logo.png";

    source.src = imgSrc;

  }

  getDefaultLogo(){
    return IMAGES_BASE_URL.imageBaseUrl + "/" + this.cartManager.getADPCustomerUUID() + "/branding/logoSquare.png?v="+Math.round((new Date()).getTime() / 1000);
  }

  getFormLogo(){
    return "http://anydatapoint.net/f9c5c5ba-3900-4cdc-946d-93979d29f33c/document/cdw-bol-body.png";
  }

  locationAddress1(addressLine1){
    if(addressLine1 === "" || addressLine1 === null || addressLine1 === undefined){
      return false;
    }
    else
    {
      return true;
    }
  }
  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad PickpacklistPage');
    // this.bolFormVariables();
  }
  decode(encodeData){
    return atob(encodeData);
  }


  processPickPackPrams(data){
    // if(data.status === "200" || data.status === "270"){
    if(data.data != ""){
      this.pickPackParamsVariables = JSON.parse(this.decodeData(data.data));
    }
    'use strict';
    // Below code is from GA to map CSV field items
    // let temp1 =  this.cart.items.map((o)=>{ return {id:o.id,Name:o.name,Quantity:o.quantity,barcode:o.barCode}});
    // this.gVLogger.log("tep1 data " + JSON.stringify(temp1) );

    let temp = [];
    let csvCustomFields = this.paramsFromServer.documents.find(item=>item.name=="ASNCSV").documentParams;

    //create an array of key value type based on the 'parameters' object the corresponding values of the linked formula
    let csvCustomFieldsObjects = this.paramsFromServer.params;
    let lineItems = this.cart.items;
    let strCart = JSON.stringify(this.cart);
    let objCart = JSON.parse(strCart);
    let objADPCust = this.salesPerson;
    let objOrder = [];
    let shiptoAddress = this.shipto;
    let TotalBeforeTax = this.TotalPriceBeforeTax;
    let index = 1;
    // let totalLength = this.lengthTotalizer.toFixed(4);

    for(let item of lineItems){
      let obj = {};
      for(let csvField of csvCustomFields){
        let label = "";
        let value = "";
        let type = "";
        let cutomFieldObj = csvCustomFieldsObjects.find(item=>item.paramId == csvField.paramId);

        type = cutomFieldObj.type;
        if( type === 'linked'){
          try{
            let itemLocal = item;
            let strExpr = cutomFieldObj.value;
            value = eval(strExpr.trim());
          }
          catch(error){
            this.gVLogger.log(error);
          }
        }
        else if(type === 'Empty'){
          try{
            let value1 = this.pickPackParamsVariables.find(item=>item.paramId == csvField.paramId).value;
            if(value1 != "" || value1 != undefined){
              value = value1;
            }
            else{
              value = "";
            }
          }
          catch(error){
            // alert("value " + value)        ;
            // this.gVLogger.log(error);
          }
        }
        else{
          value = cutomFieldObj.value;
        }
        obj[cutomFieldObj.label + "~" + cutomFieldObj.paramId] = value;
      }
      temp.push(obj);
      index ++;
    }
    // return this.cartManager.ConvertToCSVDynamically(temp);
    var blob = new Blob([this.cartManager.ConvertToCSVDynamically(temp)]);
    var a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = "For 856 EDI.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

  }

  showCalendar(){

    const dateSelected =  this.datePickerProvider.showCalendar(this.modalCtrl);


    dateSelected.subscribe(date => {
      this.gVLogger.log(date);
      var d = new Date(""+date);
      let dd:any = d.getDate();
      if( dd>0 && dd<10){
        dd = "0"+dd;
      }
      let mm:any = d.getMonth()+1; //January is 0!
      if( mm>0 && mm<10){
        mm = "0"+mm;
      }
      var output = d.getFullYear() +"-"+  mm + "-" + dd;

      this.plannedShipmentDate = output;
      this.gVLogger.log(output);
      this.cartManager.setShipDate(this.expectedShipmentDate);
    });
  }

  processEmptyPickPackParams(){
    this.gVLogger.log("else executed while read call give 404!" + JSON.stringify(this.paramsFromServer));
    // this.pickPackParamsVariables = JSON.parse(this.decodeData(data.data));
    'use strict';
    // Below code is from GA to map CSV field items
    // let temp1 =  this.cart.items.map((o)=>{ return {id:o.id,Name:o.name,Quantity:o.quantity,barcode:o.barCode}});
    // this.gVLogger.log("tep1 data " + JSON.stringify(temp1) );

    let temp = [];
    let csvCustomFields = this.paramsFromServer.documents.find(item=>item.name=="ASNCSV").documentParams;

    //create an array of key value type based on the 'parameters' object the corresponding values of the linked formula
    let csvCustomFieldsObjects = this.paramsFromServer.params;
    let lineItems = this.cart.items;
    let strCart = JSON.stringify(this.cart);
    let objCart = JSON.parse(strCart);
    let objADPCust = this.salesPerson;
    let objOrder = [];
    let shiptoAddress = this.shipto;
    let TotalBeforeTax = this.TotalPriceBeforeTax;
    let index = 1;
    // let totalLength = this.lengthTotalizer.toFixed(4);

    for(let item of lineItems){
      let obj = {};
      for(let csvField of csvCustomFields){
        let label = "";
        let value = "";
        let type = "";
        let cutomFieldObj = csvCustomFieldsObjects.find(item=>item.paramId == csvField.paramId);

        type = cutomFieldObj.type;
        if( type === 'linked'){
          try{
            let itemLocal = item;
            let strExpr = cutomFieldObj.value;
            value = eval(strExpr);
          }
          catch(error){
          }
        }
        else if(type === 'Empty'){
          try{
            let value1 = this.pickPackParamsVariables.find(item=>item.paramId == csvField.paramId).value;
            if(value1 != "" || value1 != undefined){
              value = value1;
            }
            else{
              value = "";
            }
          }
          catch(error){
          }
        }
        else{
          value = cutomFieldObj.value;
        }
        obj[cutomFieldObj.label + "~" + cutomFieldObj.paramId] = value;
      }
      temp.push(obj);
      index ++;
    }
    // return this.cartManager.ConvertToCSVDynamically(temp);
    var blob = new Blob([this.cartManager.ConvertToCSVDynamically(temp)]);
    var a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = "For 856 EDI.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  // }

  getCSVFromCARTItems(){
    this.downloadCSVButtonStatus = false;
    this.api.getADPPay("feature/getLicenseStatus?customerUUID="+this.cartManager.getADPCustomerUUID() + "&featureAlias="+ this.constants.EDI_Integrations_License_alias+"&consumptionCount=0").map(res => res.json())
      .subscribe(data => {
        if(data.status === 570 || data.status === 571 || data.status === 403){

          this.presentPaySatusAlert("Failure", data.message);
          this.downloadCSVButtonStatus = true;
          // this.presentThankYouAlert("Failure", data.message);
        }
        else if(data.status === 200 || data.status === 270){
          this.api.post("/shipmentNotice/readPickPackParams?orderId="+this.cart.orderId+"&adpCustomerUUID="+this.cartManager.getADPCustomerUUID(), "").map(res => res.json()).subscribe(  data =>{
            if(data.status === "200" && data.length != 0){
              this.processPickPackPrams(data);
            }
            else{
              this.processEmptyPickPackParams();
            }
            this.downloadCSVButtonStatus = true;
          });
        }
      });


  }

  // downloadCSV() {
  //   var blob = new Blob([this.getCSVFromCARTItems()]);
  //   var a = window.document.createElement("a");
  //   a.href = window.URL.createObjectURL(blob);
  //   a.download = "For 856 EDI.csv";
  //   document.body.appendChild(a);
  //   a.click();
  //   document.body.removeChild(a);
  // }

  getOrderStatus(){
    // this.gVLogger.log("oooooorrrrrrdddddeeeeeerrrrrSSStatusdsds", this.cart.orderStatus)
    if(this.cart.orderStatus == 2 || this.cart.orderStatus == 5){
      return true;
    }
    else{
      return false;
    }
  }

  evenOddFun(i){
    i = i /2
    if(i /2 === 0){
      return true;
    }
    else{
      return false;
    }
  }

  resetOrder(){
    let confirm = this.alertCtrl.create({
      title: 'Reset Shipment & Order',
      message: 'Are you sure? You want to reset the shipment and the order. Also any active cart in progress will be discarded!',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            //  this.gVLogger.log('Disagree clicked');
          }
        },
        {
          text: 'Agree',
          handler: () => {

            let productsList: any = [];
            for(let orderDetail of this.order.orderDetailDTOs){
              let product: any = orderDetail.productsDTO;
              productsList.push(product);
            }

            this.order.salesManId = this.cartManager.getSalesManId();

            // this.api.post("order/placeHoldOrder",order)
            // .map(res=> res.json())
            // .subscribe(data=>{
            //   if(data.status == 200){
            //     this.gVLogger.log("placeHoldOrder --- ", data);
            //   }
            // },err=>{
            //   this.presentToast("some thing going wrong with background process");
            // });


            //if(this.cartManager.getProductsCount() > 0)
            // if(productsList.length >= 0)
            // {
            //   this.gVLogger.log("if called");
            //   let confirm = this.alertCtrl.create({
            //         title: 'Are you sure?',
            //         message: "There is a cart open for '"+ this.cartManager.getCustomerName() +"'.",
            //         buttons: [
            //           {
            //             text: 'View', // cancel
            //             handler: () => {
            //               this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});
            //             }
            //           },
            //           {
            //             text: 'Continue ', // agree
            //             handler: () => {
            //               // this.cartManager.setCustomer(order.customerDTO);
            //               // this.cartManager.setOrderMessage(order.orderMessage);
            //               // this.cartManager.setOrderId(order.id);
            //               // this.cartManager.setOrderId(order.orderDetailDTOs)
            //               // this.cartManager.setShipDate(order.expectedShipmentDate);
            //               // this.cartManager.setOrderTitle(order.orderTitle);
            //               // this.cartManager.setOrderStatus(order.orderStatus);
            //               // this.cartManager.setItems(productsList);
            //               // this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});


            //               this.api.post("order/resetOrder",this.order)
            //               .map(res=> res.json())
            //               .subscribe(data=>{
            //                   if(data.status == 200){
            //                     this.gVLogger.log(" ------- placeHoldOrder -------- ", data);

            //                     if(data.data.customerDTO.dropshipLocation !== undefined && data.data.customerDTO.dropshipLocation !== '')
            //                     {
            //                       let tempdl = JSON.parse(data.data.customerDTO.dropshipLocation);
            //                       this.cart.tempShipTo = tempdl;
            //                     }

            //                     this.cartManager.setCustomer(data.data.customerDTO);
            //                     this.cartManager.setOrderMessage(data.data.orderMessage);
            //                     this.cartManager.setOrderId(data.data.id);
            //                     this.cartManager.setOrderId(data.data.orderDetailDTOs)
            //                     this.cartManager.setShipDate(data.data.expectedShipmentDate);
            //                     this.cartManager.setOrderTitle(data.data.orderTitle);
            //                     this.cartManager.setOrderStatus(data.data.orderStatus);
            //                     this.cartManager.setItems(productsList);
            //                     this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});
            //                   }
            //                 },err=>{
            //                   // this.presentToast("some thing going wrong with background process");
            //                 });

            //             }
            //           }
            //         ]
            //       });
            //       confirm.present();
            // }
            // else
            // if(this.cartManager.getProductsCount() > 0)
            // {

            // this.gVLogger.log("else called");
            // this.cartManager.setCustomer(order.customerDTO);
            // this.cartManager.setOrderMessage(order.orderMessage);
            // this.cartManager.setOrderId(order.id);
            // this.cartManager.setOrderTitle(order.orderTitle);
            // this.cartManager.setOrderStatus(order.orderStatus);
            // this.cartManager.setShipDate(order.expectedShipmentDate);
            // this.cartManager.setItems(productsList);
            // this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});



            if(this.cartManager.getProductsCount() > 0)
            {

              if(this.cartManager.getOrderId() == 0){
                this.gVLogger.log("Local Order");
                this.cartManager.clearCartProducts();
                this.cartManager.setOrderTitle("");
                this.cartManager.setOrderId(0);
                this.refreshTotalPrice();
                this.nav.setRoot(ItemsPage);
                this.cart.tempShipTo = undefined;
              }

            }

            this.api.post("order/resetOrder",this.order)
              .map(res=> res.json())
              .subscribe(data=>{
                // alert("data status : " + data.status);
                if(data.status == 200){
                  this.cartManager.setCustomer(this.order.customerDTO);
                  this.cartManager.setOrderMessage(this.order.orderMessage);
                  this.cartManager.setOrderId(this.order.id);
                  // alert("Order id that is need to be set " + this.order.id);
                  // alert("ordr id in reset" + this.cartManager.getOrderId());
                  this.cartManager.setOrderTitle(this.cart.orderTitle);
                  this.cartManager.setOrderStatus(2);
                  this.cartManager.setShipDate(this.order.expectedShipmentDate);
                  this.cartManager.setItems(productsList);
                  this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});


                }
              },err=>{
                // this.presentToast("some thing going wrong with background process");
              });

            // }
          }
        },
      ]
// }


    });
    confirm.present();

  }



  refreshTotalPrice(){
    this.cart = CART;
    let temp:number = 0;
    for(let item of this.cart.items){
      if(this.discountCheck(item.discountPrice)){
        temp =  temp + (Number(item.discountPrice) * Number(item.quantity));
      }else{

        temp =  temp + (Number(item.price) * Number(item.quantity));
      }
    }
    this.TotalPriceBeforeTax =  Number(temp.toFixed(2));
    this.TAX = (this.TotalPriceBeforeTax * this.taxPercent);
    this.TotalPrice = this.TotalPriceBeforeTax + this.TAX;
    //alert(JSON.stringify(this.cart));
  }

  locationTypeCheck(locationsDTOs){

    for(let loc of locationsDTOs){
      // this.gVLogger.log("looooooooooop" + JSON.stringify(loc));
      if(loc.locationType === "BILLTO" || loc.locationType === "BILLTOSHIPTO"){
        // this.gVLogger.log("enetrrrrrr in if condition........." + loc);
        return this.selectFirstBillTo = loc;
      }
    }
  }

  bolFormVariables(){
    this.api.post("/shipmentNotice/readPickPackParams?orderId="+this.cart.orderId+"&adpCustomerUUID="+this.cartManager.getADPCustomerUUID(), "").map(res => res.json()).subscribe(  data =>{
      if(data.status === "200" || data.status === "270"){
        try{
          this.pickPackParamsVariables = JSON.parse(this.decodeData(data.data));
          this.SoldToCompany = this.pickPackParamsVariables.find(item=>item.paramId == 73).value;
          this.SoldToAddress = this.pickPackParamsVariables.find(item=>item.paramId == 74).value;

        }catch(err){

          this.pickPackParamsVariables = "";
          this.SoldToCompany = "";
          this.SoldToAddress = "";
        }
        let bolCustomFields = this.paramsFromServer.documents.find(item=>item.name=="BOLForm").documentParams.find(Item=>Item.sectionLabel=="BOLHeader").fields;
        let csvCustomFieldsObjects = this.paramsFromServer.params;
        // alert("bolCustomFields " + JSON.stringify( bolCustomFields));
        let lineItems = this.cart.items;
        let strCart = JSON.stringify(this.cart);
        let objCart = JSON.parse(strCart);
        let objADPCust = this.salesPerson;
        let objOrder = [];
        let shiptoAddress = this.shipto;
        let TotalBeforeTax = this.TotalPriceBeforeTax;
        let index = 1;
        // let totalLength = this.lengthTotalizer.toFixed(2);
        this.BOLVariables = [];
        for(let csvField of bolCustomFields){
          let obj ;
          let label = "";
          let value = "";
          let type = "";
          let cutomFieldObj = csvCustomFieldsObjects.find(item=>item.paramId == csvField.paramId);

          type = cutomFieldObj.type;
          if( type === 'linked'){
            // alert("if called of linked" + cutomFieldObj.value);
            try{

              let strExpr = cutomFieldObj.value;
              value = eval(strExpr);
              // alert("if called of  after eval" + value);
            }
            catch(error){
              // alert("catch" + error);
            }
          }
          else if(type === 'Empty'){
            try{
              let value1 = this.pickPackParamsVariables.find(item=>item.paramId == csvField.paramId).value;
              if(value1 != "" || value1 != undefined){
                // alert("value " + value1);
                value = value1;
              }
              else{
                value = "";
              }
            }
            catch(error){
            }
          }
          else{
            value = cutomFieldObj.value;

          }
          // alert("value : " + value)
          obj = {
            "label" : cutomFieldObj.label,
            "value" : value
          }
          this.BOLVariables.push(obj);
        }
      }
      else{
        try{
          this.SoldToCompany = this.pickPackParamsVariables.find(item=>item.paramId == 73).value;
          this.SoldToAddress = this.pickPackParamsVariables.find(item=>item.paramId == 74).value;
        }catch(error){
          this.gVLogger.log("error");
        }
        let bolCustomFields = this.paramsFromServer.documents.find(item=>item.name=="BOLForm").documentParams.find(Item=>Item.sectionLabel=="BOLHeader").fields;
        let csvCustomFieldsObjects = this.paramsFromServer.params;
        // alert("bolCustomFields " + JSON.stringify( bolCustomFields));
        let lineItems = this.cart.items;
        let strCart = JSON.stringify(this.cart);
        let objCart = JSON.parse(strCart);
        let objADPCust = this.salesPerson;
        let objOrder = [];
        let shiptoAddress = this.shipto;
        let TotalBeforeTax = this.TotalPriceBeforeTax;
        let index = 1;
        // let totalLength = this.lengthTotalizer.toFixed(4);
        this.BOLVariables = [];
        for(let csvField of bolCustomFields){
          let obj ;
          let label = "";
          let value = "";
          let type = "";
          let cutomFieldObj = csvCustomFieldsObjects.find(item=>item.paramId == csvField.paramId);

          type = cutomFieldObj.type;
          if( type === 'linked'){
            // alert("if called of linked" + cutomFieldObj.value);
            try{

              let strExpr = cutomFieldObj.value;
              value = eval(strExpr);
              // alert("if called of  after eval" + value);
            }
            catch(error){
              // alert("catch" + error);

            }
          }
          else if(type === 'Empty'){
            try{
              let value1 = this.pickPackParamsVariables.find(item=>item.paramId == csvField.paramId).value;
              if(value1 != "" || value1 != undefined){
                // alert("value " + value1);
                value = value1;
              }
              else{
                value = "";
              }
            }
            catch(error){

            }
          }
          else{
            value = cutomFieldObj.value;

          }
          // alert("value : " + value)
          obj = {
            "label" : cutomFieldObj.label,
            "value" : value
          }
          this.BOLVariables.push(obj);
        }
      }
    });

  }

  checkCompanyName(name){
    // alert(name);
    if(name != "" && name != undefined){
      return true;
    }
    else{
      return false;
    }
  }


  chooseFromLocations(product){
    let backup = JSON.stringify(product);
    this.api.get("/products/getProductsForPickShip/" + product.id).map(res => res.json()).subscribe(data => {
      if(data.status === "200"){

        let productLocationsModel = this.modalCtrl.create(ProductLocationsModelPage, { product: backup ,orderStatus: 1, data : data.data }, {cssClass : "productLocationStyle"});
        productLocationsModel.onDidDismiss(dataFromProductLocationsModel => {
          this.gVLogger.log("Data from product location model : " + dataFromProductLocationsModel);
          if(dataFromProductLocationsModel !== null && dataFromProductLocationsModel !== undefined){
          }
        })
        productLocationsModel.present();
      }
    });

  }

  prodTotalQty(product){
    // this.gVLogger.log("Shipped SSSSSSSSSSSSSSSSSSSSS" + this.shipmentStatus);

    if(this.shipmentStatus === false){
      let prodTotalQty = 0;
      // this.gVLogger.log("product in prodTotalQty : " + JSON.stringify(product));
      for(let qty of product.productInventoryLocationsDTO) {
        prodTotalQty += qty.quantityShipped;
      }
      return prodTotalQty;
    }else {
      let prodTotalQty = 0;
      // this.gVLogger.log("product in prodTotalQty : " + JSON.stringify(product));
      for(let qty of product.productInventoryLocationsDTO) {
        prodTotalQty += qty.quantityReceived;
      }
      return prodTotalQty;
    }

  }

  totalQuantityOfSelectedProducts(){
    this.totalQtyOfSelectedProducts = 0
    for (let product of this.cart.items){
      for(let qty of product.productInventoryLocationsDTO){
        if(qty.status === 1){
          this.totalQtyOfSelectedProducts += qty.quantityReceived;
        }
      }
    }
  }

  productInventoryLocationsDTO(product){

    // this.gVLogger.log("Product inventory location : " + product)

    if(this.shipmentStatus === false){
      let prodTotalQty = 0;
      for(let qty of product.productInventoryLocationsDTO) {
        prodTotalQty += qty.quantityShipped;
      }

      if(product.productInventoryLocationsDTO !== null && product.productInventoryLocationsDTO !== undefined && product.productInventoryLocationsDTO.length > 0){
        for(let qtyreceived of product.productInventoryLocationsDTO){
          if(qtyreceived.status === 1 && prodTotalQty > 0){
            return true;
          }
        }
        return false;
      }
      else {
        return false;
      }
    }else {
      let prodTotalQty = 0;
      for(let qty of product.productInventoryLocationsDTO) {
        prodTotalQty += qty.quantityReceived;
      }

      if(product.productInventoryLocationsDTO !== null && product.productInventoryLocationsDTO !== undefined && product.productInventoryLocationsDTO.length > 0){
        for(let qtyreceived of product.productInventoryLocationsDTO){
          if(qtyreceived.status === 1 && prodTotalQty > 0){
            return true;
          }
        }
        return false;
      }
      else {
        return false;
      }
    }

   //  let prodTotalQty = 0;
   //  for(let qty of product.productInventoryLocationsDTO) {
   //    prodTotalQty += qty.quantityReceived;
   //  }
   //
   // if(product.productInventoryLocationsDTO !== null && product.productInventoryLocationsDTO !== undefined && product.productInventoryLocationsDTO.length > 0){
   //   for(let qtyreceived of product.productInventoryLocationsDTO){
   //     if(qtyreceived.status === 1 && prodTotalQty > 0){
   //       return true;
   //     }
   //   }
   //   return false;
   // }
   // else {
   //   return false;
   // }

  }

  viewItem(item) {

    this.api.get("product/" + item.id + "/?isWebStore=" + 1).map(res => res.json()).subscribe(data => {
      if(data.status === "200"){
        item.description = data.data.description;
      }
    })
    this.nav.push(ItemPage, {item: item})
  }

  getCutomerOrderNumber(customerOrderNumber){
    if(customerOrderNumber !== undefined && customerOrderNumber !== null){
      return customerOrderNumber.trim()
    }else {
      return ""
    }
  }


  removeItemFromCart(pro){
    var index= this.cart.items.map(function(x) {return x.id; }).indexOf(pro.id);
    if (index != -1) {
      this.cart.items.splice(index, 1);
      this.totalQuantityOfSelectedProducts();
      this.setTotalLength();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/shipment-ready/shipment-ready.ts